import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateEOIStatus } from '~/services/AgentHub/AgentService';

interface UpdateEoiStatusParams {
  id: string;
  status: 'approved' | 'rejected';
}

export function useUpdateEoiStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, status }: UpdateEoiStatusParams) => {
      return await updateEOIStatus(id, status);
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(['eoi', variables.id], data);
      queryClient.invalidateQueries({ queryKey: ['list-eoi'] });
    },
  });
}
